import {
  AuthorizedUserType,
  InviteStatus,
} from '@Store/slices/authOnboarding/authOnboarding.types.ts';
import type { StateCreator } from 'zustand';
import type { IAuthOnboardingSlice } from '@Store/slices/authOnboarding/authOnboarding.types.ts';

export const createAuthOnboardingSlice: StateCreator<IAuthOnboardingSlice> = (set, get) => ({
  authOnboardingSlice: {
    customerId: '',
    customerFirstName: '',
    customerLastName: '',
    customerBusinessName: '',
    authorizedUserFullName: '',
    inviteStatus: InviteStatus.ACTIVE,
    authorizedUserType: AuthorizedUserType.ACCOUNTANT,
    consentFormData: null,
  },
  setAuthOnboardingData: (data) => {
    set(() => ({ authOnboardingSlice: data }));
  },
  getAuthUserType: () => get().authOnboardingSlice.authorizedUserType,
  getOnboardingType: () => get().authOnboardingSlice.onboardingType,
  getAuthUserAccessToken: () => get().authOnboardingSlice.accessToken || '',
  setAuthUserAccessToken: (token) =>
    set(() => ({ authOnboardingSlice: { ...get().authOnboardingSlice, accessToken: token } })),
  setConsentFormData: (formData) =>
    set(() => ({
      authOnboardingSlice: { ...get().authOnboardingSlice, consentFormData: formData },
    })),
  getConsentFormData: () => get().authOnboardingSlice.consentFormData || null,
  setAuthUserIsUsFlow: (isUs) =>
    set(() => ({ authOnboardingSlice: { ...get().authOnboardingSlice, isUsFlow: isUs } })),
  getAuthUserIsUsFlow: () => get().authOnboardingSlice.isUsFlow ?? true,
  setAuthUserDocVData: (data) =>
    set(() => ({ authOnboardingSlice: { ...get().authOnboardingSlice, docVData: data } })),
  getAuthUserDocVData: () => get().authOnboardingSlice.docVData || null,
  getAccountantPermissionLevel: () => get().authOnboardingSlice.accountantPermissionLevel,
});
